import { Link } from "react-router-dom";
import { useLang } from "@/App";
import { all, pick, seq } from "@/data/images";
import Hero from "@/components/Hero";
import Foto from "@/components/Foto";
import GaleriaGrid from "@/components/GaleriaGrid";
import { Reveal, Pretitulo, TituloSeccion, BtnPrimario } from "@/components/Reveal";

export default function QueHacer() {
  const { t, L } = useLang();
  const p = t.queHacer;
  const g = t.global.footer;

  return (
    <div data-testid="pagina-que-hacer">
      <Hero pre={p.hero.pre} titulo={p.hero.titulo} fotos={[pick(p.hero.foto[0], 0) || all(p.hero.foto[0])[0]]} testid="hero-que-hacer" />

      {/* 2. Presentación */}
      <section className="py-20 md:py-28" data-testid="qh-presentacion">
        <div className="mx-auto max-w-3xl px-6 md:px-10">
          <Reveal>
            <Pretitulo>{p.presentacion.pre}</Pretitulo>
            <h2 className="mt-4 text-center font-serif text-3xl font-light tracking-tight text-ink md:text-5xl">{p.presentacion.titulo}</h2>
            <p className="mt-7 text-[15.5px] leading-relaxed text-ink-soft">{p.presentacion.cuerpo}</p>
          </Reveal>
        </div>
      </section>

      {/* 3. Tres experiencias */}
      <section className="pb-20 md:pb-28" data-testid="qh-actividades">
        <div className="mx-auto max-w-[1300px] px-6 md:px-10">
          <div className="grid gap-8 md:grid-cols-3 md:gap-6">
            {p.actividades.map((a, i) => (
              <Reveal key={a.t} delay={i * 0.08} className="flex flex-col" testid={`qh-actividad-${i}`}>
                <Link to={L(a.to)} className="group flex h-full flex-col" data-testid={`qh-actividad-card-${i}`}>
                  <div className="img-frame aspect-[4/3] w-full">
                    <Foto src={pick(a.foto[0], 0) || all(a.foto[0])[0]} alt={a.t} className="h-full w-full" />
                  </div>
                  <h3 className="mt-6 font-serif text-2xl font-light text-ink">{a.t}</h3>
                  <p className="mt-3 flex-1 text-sm leading-relaxed text-ink-soft">{a.d}</p>
                  <span className="mt-5 inline-flex w-fit border-b border-terra pb-1 text-[11px] font-bold tracking-[0.22em] text-terra">
                    {g.leerMas}
                  </span>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* 4. Galería */}
      <section className="pb-20 md:pb-28" data-testid="qh-galeria">
        <div className="mx-auto max-w-[1360px] px-6 md:px-10">
          <TituloSeccion pre={p.galeria.pre} titulo={p.galeria.titulo} />
          <GaleriaQH config={p.galeria} />
          <div className="mt-10 text-center">
            <BtnPrimario href="fotos/que-hacer" testid="qh-galeria-ver-btn">VER GALERÍA</BtnPrimario>
          </div>
        </div>
      </section>
    </div>
  );
}

function GaleriaQH({ config }) {
  const hero = pick(config.usar, 0) || all(config.usar)[0];
  const excl = hero ? [hero.split("/").pop()] : [];
  const fotos = [hero, ...seq(config.carpeta, 10, excl).filter((f) => f !== hero)].filter(Boolean).slice(0, 10);
  return <GaleriaGrid fotos={fotos} columnas={5} testid="qh-galeria-grid" />;
}